import React from 'react';
import { Table, Tbody, Td, Th, Thead, Tr } from '@televet/kibble-ui';
import { WorkflowEventAction } from 'shared/types/graphql';
import AssigneeSelector from '../../AssigneeSelector';

export type AutomationTaskRow = {
  taskName: string;
  automationName: string;
  assigneeIds: string[];
  settingId: string;
  getUpdatedAction: (finalAssigneeList: string[]) => Partial<WorkflowEventAction>;
};

type AutomationTaskTableProps = {
  data: AutomationTaskRow[];
  onUpdateAction: (settingId: string, updatedAction: Partial<WorkflowEventAction>) => void;
  hasPermission: boolean;
};

const AutomationTaskTable = ({ data, onUpdateAction, hasPermission }: AutomationTaskTableProps): JSX.Element => (
  <Table width="100%" textAlign="left" verticalAlign="middle" fontWeight="normal">
    <Thead>
      <Th textTransform="uppercase" pb={3} px={2} fontWeight="normal">Automation Name</Th>
      <Th textTransform="uppercase" pb={3} px={2} fontWeight="normal">Task Name</Th>
      <Th textTransform="uppercase" pb={3} px={2} fontWeight="normal">Assignees</Th>
    </Thead>
    <Tbody>
      {data.map(({ settingId, assigneeIds, automationName, taskName, getUpdatedAction }, index) => (
        <Tr
          key={`${settingId}_${taskName}_${index}`}
          _odd={{ bg: 'background.default' }}
          css={`&:last-of-type td {border-bottom: none;}`}
        >
          <Td py={3} px={2} fontSize="sm">{automationName}</Td>
          <Td py={3} px={2} fontSize="sm">{taskName}</Td>
          <Td py={3} px={2} fontSize="sm">
            <AssigneeSelector
              selectedUserIds={assigneeIds}
              onToggle={hasPermission ? (option): void => {
                const finalIds = option.isSelected
                  ? assigneeIds.filter((id) => id !== option.value.id)
                  : [...assigneeIds, option.value.id];
                const updatedAction = getUpdatedAction(finalIds);
                onUpdateAction(settingId, updatedAction);
              } : undefined}
            />
          </Td>
        </Tr>
      ))}
    </Tbody>
  </Table>
);

export default AutomationTaskTable;
